import { DetailedHTMLProps, FC, InputHTMLAttributes, ReactElement } from 'react';

import styles from './radio.module.scss';

interface IRadioProps
  extends DetailedHTMLProps<InputHTMLAttributes<HTMLInputElement>, HTMLInputElement> {
  label?: string;
}

const Radio: FC<IRadioProps> = (props): ReactElement => {
  const { type = 'radio', id, label, ...restProps } = props;
  return (
    <div className={styles.radio}>
      <input id={id} type={type} className={styles.input} {...restProps} />
      {label && (
        <label htmlFor={id} className={styles.label}>
          {label}
        </label>
      )}
    </div>
  );
};

export { Radio };
